(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('timestampSettings', {
        templateUrl: 'views/components/views/timestampSettings/timestampSettings.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['stateService', function (stateService) {
            const vm = this;
            
            vm.model = {
                name: stateService.getCurrentName()
            };
        }]
    });
})();
